/** Roles that use operations-style lead attachments (see FileUploadOP / FileUploadSales). */
const OPS_ATTACHMENT_ROLES = [
  "project manager",
  "operations",
  "operations manager",
  "operations person",
];

export function parseCustomRoles(raw) {
  if (raw == null || raw === "") return [];
  const s = String(raw).trim();
  try {
    const j = JSON.parse(s);
    if (Array.isArray(j)) {
      return j.map((x) => String(x).trim().toLowerCase()).filter(Boolean);
    }
  } catch {
    /* ignore */
  }
  return s
    .split(/[|,]/)
    .map((x) => x.trim().toLowerCase())
    .filter(Boolean);
}

/** Auth levels that use CRM-wide attachment rules — never operations-style (grey PO/contract) UI. */
const NON_OPS_ATTACHMENT_AUTH = new Set(["L0", "L1", "L2", "L3", "L5"]);

export function isAdminAuthLevel(authLevel) {
  const normalizedAuth = String(authLevel || "").trim().toUpperCase();
  return normalizedAuth === "L0";
}

/**
 * Operations person / manager: L4 auth or matching customRoles from login.
 * Directors (L1) etc. are excluded even if `Roles` still lists "operations" / "project manager" after a user switch.
 */
export function isOperationsLeadAttachmentUser(authLevel, rolesRaw) {
  const normalizedAuth = String(authLevel || "").trim().toUpperCase();
  if (NON_OPS_ATTACHMENT_AUTH.has(normalizedAuth)) {
    return false;
  }
  if (normalizedAuth === "L4") return true;
  const tokens = parseCustomRoles(rolesRaw);
  return tokens.some((t) => OPS_ATTACHMENT_ROLES.includes(t));
}

export function getLeadAttachmentCategory(file) {
  return String(file?.category || file?.selectedCategory || "").trim();
}

export function isOpsPurchaseOrderOrContract(file) {
  const c = getLeadAttachmentCategory(file);
  return c === "Purchase Order" || c === "Contract";
}

/** Rows to show for ops users: no Quote; PO & Contract shown but greyed / no download. */
export function filterFilesForOperationsAttachmentView(files) {
  const list = Array.isArray(files) ? files : [];
  return list
    .filter((f) => getLeadAttachmentCategory(f) !== "Quote")
    .slice()
    .sort((a, b) => {
      const ra = isOpsPurchaseOrderOrContract(a) ? 1 : 0;
      const rb = isOpsPurchaseOrderOrContract(b) ? 1 : 0;
      return ra - rb;
    });
}
